(function () {
  // --- Abas (desktop) / accordion (mobile) ---
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-pdp-tab]');
    var panels = root.querySelectorAll('[data-pdp-panel]');
    if (!tabs.length) return;
    function activate(id) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-pdp-tab') === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.classList.toggle('is-active', on);
      });
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-pdp-panel') !== id;
      });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { activate(t.getAttribute('data-pdp-tab')); });
    });
    activate(tabs[0].getAttribute('data-pdp-tab'));
  }

  // --- Barra fixa mobile (aparece quando o ATC principal sai da viewport) ---
  function initStickyBar() {
    var bar = document.querySelector('[data-pdp-mobilebar]');
    var anchor = document.querySelector('[data-pdp-buybox-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-visible', !e.isIntersecting);
        document.body.classList.toggle('pdp-bar-on', !e.isIntersecting);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    io.observe(anchor);
  }

  function initMinQty(){
    document.querySelectorAll('input[name="quantity"]').forEach(function(inp){
      var min=parseInt(inp.getAttribute('min')||'1',10);
      if(min<2)return;
      function clamp(){var v=parseInt(inp.value||'0',10);if(isNaN(v)||v<min)inp.value=min;}
      clamp();
      inp.addEventListener('change',clamp);
      var box=inp.closest('.quantity-selector');
      if(box)box.addEventListener('click',function(){setTimeout(clamp,0);});
    });
  }

  function init() {
    document.querySelectorAll('[data-pdp-tabs]').forEach(initTabs);
    initStickyBar();
    initMinQty();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
